module.exports = __webpack_public_path__ + "static/minixels_preview-c45e591d20cda2ab3055eb54273a3842.jpg";